import {
    REFRESH_COMPONENTS,
    ADD_SEARCH_COMPONENTS,
    ADD_EMPTY_SEARCH_COMPONENTS,
    CLEAN_SEARCH,
} from "./mutations-type";
import { MutationTree } from "vuex";
import { IComponentState } from "./state";
import { IComponent } from "@/models";

export const mutations: MutationTree<IComponentState> = {
    [REFRESH_COMPONENTS](state, payload: IComponent[]): void {
        state.components = payload;
    },

    [ADD_SEARCH_COMPONENTS](state, data: IComponent[]): void {
        state.searchComponents = data;
    },

    [CLEAN_SEARCH](state): void {
        state.searchComponents = [];
    },
};
